import * as React from "react";
import Button from "@mui/material/Button";
import Box from  "@mui/material/Box";
import { Input } from '@mui/material';
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useMutation,
} from "react-query";
import { useState } from "react";
import { useEffect } from "react";
import BAVButton from "./BAVButton";
import BAVMenuButton from "./BAVMenuButton";
import { convertUTCDateToLocalDate } from '../utils/Util.jsx';
import { msalInstance } from "../index";
import { getUserToken } from "../utils/AuthTokenReader.jsx";
import Alert from "@mui/material/Alert";

const queryClient = new QueryClient();

export default function PfSearchDialog({ kunde, callback, sparplan, sparplanCallback,  vorsorgeCallback }) {
  return (
    <QueryClientProvider client={queryClient}>
      <PfSearch kunde={kunde} callback={callback} sparplan={sparplan}/>
    </QueryClientProvider>
  );
}

function PfSearch({ kunde, callback, sparplan}) {
    const [showAlert, setShowAlert] = useState(false);
    const [alertData, setAlertData] = useState({ severity: "info", text: "" });
    // Auth Token
    const [options, setOptions] = useState();
    const [token, setToken] = useState();
    const initToken = async () => {
        const ltoken = await getUserToken();
        setToken(ltoken);
        const headers = new Headers();
        const bearer = `Bearer ${ltoken.accessToken}`;
        headers.append("Authorization", bearer);
        headers.append("Content-Type", "application/json");
        setOptions({ headers: headers });
    };

    const account = msalInstance.getActiveAccount();
    useEffect(() => {
        initToken();
    }, []);
    const handleCloseAlert = () => {
        setShowAlert(false);
;
    };
  const handleNewPortfolio = (portfolioType) => {
      var entryType = 0;
      switch (portfolioType) {
        case "VV":
          case "BM":
              entryType = 2;
            break;
        case "SP":
              entryType = 3;
            break;
        case "3A":
        case "FZ":
              entryType = 4;
            break;
    }
    const newPortfolio = {
        customerId: kunde.customerId,
        kdLnr: kunde.kdLnr,
        kdNr: kunde.kdNr,
        rubrik: "Portfolio",
        editKtGnr: kunde.editKdNr + "-00",
        ktGnr: kunde.kdNr + "" + "00",
        kdBeratBez: "",
        portfolioType: portfolioType,
        createDate: convertUTCDateToLocalDate(new Date()),
        createdBy: account.name,
        changeDate: convertUTCDateToLocalDate(new Date()),
        changedBy: account.name
        
      };
      handlePostPortfolio(newPortfolio, entryType);
  }
 
  const postPortfolio = async (portfolioData) => {
    const response = await fetch("/portfolios", {
            method: "POST",
            headers: options.headers,
            body: JSON.stringify(portfolioData),
    });

    if (!response.ok) {
        const msg = await response.text();
            throw new Error(msg);
        }
        const data = await response.json();
        return data;
    };
  
    const postMutation = useMutation(postPortfolio);

  const handlePostPortfolio = async (newPf, entryType) => {
        try {
            const postedPortfolio = await postMutation.mutateAsync(newPf);
            if (postedPortfolio) {
                var portfolioId = postedPortfolio.portfolioId;
            } else {
                throw new Error("Keine PortfolioId erhalten");
            }
        } catch (error) {
            var retErr = JSON.parse(error.toString().substring(error.toString().indexOf("{")))
            setAlertData({
                severity: "error",
                text: <div>{retErr.detail}</div>
            });
            setShowAlert(true);
            return;
      }
        callback(portfolioId, entryType);
    };
  return (
    <>
    {sparplan==true &&
            <BAVMenuButton
                  opener={handleNewPortfolio}
                  pf={false}
         >
         Neu
         </BAVMenuButton>
    }
          {!sparplan && <BAVMenuButton
              opener={handleNewPortfolio}
              pf={true}
          >
              Neu
          </BAVMenuButton>
      }
          {showAlert && (
              <Alert severity={alertData.severity} onClose={handleCloseAlert}>
                  {alertData.text}
              </Alert>
          )}
     
    </>
  );
}
